import { getInfosLoja } from '../../service/api';
import { useEffect, useState } from 'react';
import { InfosLoja } from '../../shared/types';
import { InfosLoja as InfosLojaDictionary } from '../../shared/utils/dictionary';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

export const HeaderAdmin = () => {

    const [infosLojaResult, setInfosLojaResult] = useState<InfosLoja>()
    const navigate = useNavigate()

    const infosLoja = async () => {
        try {
            const result = await getInfosLoja();
            setInfosLojaResult(result?.data)
        } catch {

        }
    }

    useEffect(() => {
        infosLoja()
    },[])
      
    return (
        <div className='bg-primary w-full h-20 flex justify-between items-center px-5'>
            <a href='/admin' className='text-white text-lg'>{infosLojaResult?.[InfosLojaDictionary.LOJA][InfosLojaDictionary.NOME]}</a>
            <div tabIndex={0} role="button" onClick={() => {
                Cookies.remove('token');
                navigate('/admin')
            }} className="btn m-1 bg-transparent border-none hover:bg-transparent text-white"><i className="ri-logout-box-line ri-xl"></i></div>
        </div>
    )
}